import React from 'react';
import { QualificationsListContainer } from '../../containers';

const QualificationsListPage = () => <QualificationsListContainer />;

export default QualificationsListPage;
